export interface ClientProject {
    id: number;
    contactId: number;
    projectName: string;
    projectAddress: string;
    projectCity: string;
    projectPostCode: string;

    companyName: string;
    companyRegNo: string;
    email: string;
    mobile: string;
    landline: string;
    address: string;
    city: string;
    postCode: string;
}

export const mapClientProject = (data:any): ClientProject => {
    if(!data){
        throw new Error('Invalied employee type')
    }


    const clientProject: ClientProject = {
        id: data.id,
        contactId: data.contact_id,
        projectName: data.project_name,
        projectAddress: data.project_address,
        projectCity: data.project_city,
        projectPostCode: data.project_post_code,
        
        companyName: data.company_name,
        companyRegNo: data.company_regno,
        email: data.company_email,
        mobile: data.company_phone,
        landline: '',
        address: data.company_address,
        city: data.company_city,
        postCode: data.company_post_code,
    
    }

    return clientProject;

}

export const mapClientProjects = (data: any[]): ClientProject[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid Employee data');
    }
  
    return data.map(mapClientProject);
  };